import { Box } from '@material-ui/core';
import { Channel, UserType } from '@nemuru-eng/js-api-client';

import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { UserListColumn } from '@/components/shared/components/UserList/types/TableProps';
import { UserList } from '@/components/shared/components/UserList/UserList';
import { ModuleCorePermissionProps, PendingDataType } from '@/config/types';

interface AgentsCredentialsTableProps extends ModuleCorePermissionProps {
  channel?: Channel;
}

export const AdminCredentialsTable = ({ canEdit, channel }: AgentsCredentialsTableProps) => {
  if (!channel)
    return (
      <Box mt={'100px'}>
        <PendingDataWarning type={PendingDataType.NO_CHANNELS_SELECTED} />;
      </Box>
    );

  return (
    <UserList
      editModeAllowed={canEdit}
      userIds={[channel.id]}
      userType={UserType.CHANNEL}
      hideSubsectionWrapper={true}
      tableProps={{ users: undefined, columnsToHide: [UserListColumn.ICON, UserListColumn.ROLES] }}
    />
  );
};
